import React from 'react';
import { Navigate } from 'react-router-dom';

const AdminLoginRedirect = () => {
  if (localStorage.getItem('admin_token')) {
    return <Navigate to="/admin/interns" replace />;
  }
  if (localStorage.getItem('intern_token')) {
    return <Navigate to="/intern/portal" replace />;
  }
  return <Navigate to="/admin/login" replace />;
};

export default AdminLoginRedirect;
